module.exports = __webpack_public_path__ + "img/重庆大学.f0fff9cd.png";